import React from 'react';
import './PrivacyPolicy.css';

const BasicPage = () => {
  return (
    <div className="privacy-policy content pt-0">
      <div className="row">
        <div className="card mb-2 mt-4">
          <div className="card-body">
            <h1>Política de Privacidad</h1>
            <h2>1. Introducción</h2>
            <p>En [Nombre de la Empresa] valoramos y respetamos su privacidad. Esta Política de Privacidad explica cómo recopilamos, utilizamos y protegemos la información personal que usted nos proporciona al utilizar nuestra aplicación de gestión de empresas [Nombre de la Aplicación].</p>
            <h2>2. Datos que Recopilamos</h2>
            <p>Recopilamos los siguientes tipos de datos personales:</p>
            <ul>
              <li>Información de contacto (nombre, correo electrónico, número de teléfono).</li>
              <li>Información de facturación (dirección, método de pago).</li>
              <li>Datos de uso (historial de acceso, interacciones con la aplicación).</li>
              <li>Información técnica (dirección IP, tipo de navegador, sistema operativo).</li>
            </ul>
            <h2>3. Uso de los Datos</h2>
            <p>Utilizamos los datos recopilados para:</p>
            <ul>
              <li>Proveer y mejorar nuestros servicios.</li>
              <li>Gestionar su cuenta y ofrecer soporte técnico.</li>
              <li>Cumplir con obligaciones legales.</li>
              <li>Enviar actualizaciones, noticias y ofertas relevantes, siempre que se haya dado el consentimiento.</li>
            </ul>
            <h2>4. Compartir Información</h2>
            <p>No compartimos, vendemos ni alquilamos su información personal a terceros, salvo en los siguientes casos:</p>
            <ul>
              <li>Para cumplir con requisitos legales.</li>
              <li>Con proveedores de servicios que nos ayudan a operar la aplicación, siempre bajo acuerdos de confidencialidad.</li>
            </ul>
            <h2>5. Seguridad</h2>
            <p>Implementamos medidas técnicas y organizativas adecuadas para proteger sus datos personales frente a accesos no autorizados, pérdidas o alteraciones.</p>
            <h2>6. Derechos del Usuario</h2>
            <p>Usted tiene derecho a acceder, rectificar, borrar o limitar el tratamiento de sus datos. También puede oponerse al tratamiento o solicitar la portabilidad de sus datos contactándonos en [correo electrónico de contacto].</p>
            <h2>7. Cambios en la Política de Privacidad</h2>
            <p>Nos reservamos el derecho a modificar esta Política de Privacidad en cualquier momento. Las modificaciones serán efectivas desde el momento de su publicación en nuestra plataforma.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicPage;
